<form [formGroup]="formGroup" class="w-auto p-1">

  <div class="d-flex fd-col gap-16-px mb-24">
    <span class=" d-flex subtitle-section text-color-white text-size-18 text-weight-500 lh-20-px">
      Zona
      <a class="serch subtitle-card cursor-pointer ml-auto" (click)="cleanFilter()">
        Limpiar
      </a>
    </span>
    <div class="d-flex fd-col">
      <mat-chip-listbox formControlName="zones" multiple>
        <mat-chip-option *ngFor="let zone of zoneList" [value]="zone.value">{{ zone.name }}
        </mat-chip-option>
      </mat-chip-listbox>
    </div>
  </div>
  <div class="d-flex fd-col gap-16-px mb-24">
    <span class="subtitle-section text-color-white text-size-18 text-weight-500 lh-20-px">
      Estado
    </span>
    <div class="d-flex fd-col">
      <mat-chip-listbox formControlName="status" multiple>
        <mat-chip-option *ngFor="let status of statusParkingList" [value]="status.value">{{
          status.name }}
        </mat-chip-option>
      </mat-chip-listbox>
    </div>
  </div>
  <div class="footer-buttons">
    <button class="button-apply" (click)="applyFilter()">APLICAR</button>
  </div>
</form>